import { defineComponent } from 'vue';
import UploadFile from '@/presentation/components/import-file/upload-file/upload-file.vue';
import SubmitButton from '@/presentation/components/import-file/submit-button/submit-button.vue';
import ImportFileCode from '@/presentation/pages/import-file/import-file.code';

export default defineComponent({
	components: {
		UploadFile,
		SubmitButton
	},
	setup: () => {
		const code = new ImportFileCode();

		return {};
	}
});
